import { useShellStore } from '../shared/store/useShellStore'

// frontend-restructuring §1b — width of `.control-menu1`.
//
// A route-derived default, overridden by the user's last resize drag (`customMenuWidth` in
// `useShellStore`, cleared on navigation), zeroed while the menu is collapsed, and forced to
// near-fullwidth while a fullscreen screen-share is up. Both `AppShell` (the
// `--control-menu-width` CSS var on `.home-container`) and `SpaceScreen` (the actual
// `.control-menu1` element + the `ComponentMySpacesList` offset) need the same number, so it
// lives in a shared hook. Pass the route flags in — the caller already has them from its one
// `useAppShellRoute()` call, and calling that hook again here would double its effects.

export const MIN_MENU_WIDTH = 150
export const MAX_MENU_WIDTH = 800

export function useMenuWidth({ isDocs, isCalendar, isUserProfile, isDatabase, isDappView, isTask }) {
  const collapsed = useShellStore((s) => s.menuCollapsed)
  const customMenuWidth = useShellStore((s) => s.customMenuWidth)
  const fullScreenStream = useShellStore((s) => s.fullScreenStream)

  const getDefaultWidth = () => {
    if (fullScreenStream) return 'calc(100vw - 60px)'
    if (isDocs) return '300px'
    if (isCalendar) return '350px'
    if (isUserProfile) return '350px'
    if (isDatabase) return '180px'
    if (isDappView) return '367px'
    if (isTask) return '200px'
    return '367px' // Home, Profile, Settings
  }

  const expanded = isCalendar
    ? '230px'
    : (customMenuWidth ? `${customMenuWidth}px` : getDefaultWidth())
  const menuWidth = collapsed ? '0px' : expanded
  const menuWidthPx = collapsed ? 0 : (customMenuWidth || parseInt(getDefaultWidth(), 10) || 367)

  return { menuWidth, menuWidthPx, getDefaultWidth }
}
